import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class EmissionLifePermissions extends BaseScenesPermissions {}

export default EmissionLifePermissions
